module.exports = __webpack_public_path__ + "assets/img/5-320x320.a72cb74e.webp";